import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Signaalkaarten} from '../signaalkaarten';
import {Signaalkaart} from '../signaalkaart';

@Component({
    selector: 'zah-signaalkaarten',
    templateUrl: './signaalkaarten.component.html',
    styleUrls: ['./signaalkaarten.component.scss'],
    standalone: false
})
export class SignaalkaartenComponent {

  @Input()
  signaalkaarten: Signaalkaarten;
  @Output()
  signaalkaartClicked: EventEmitter<Signaalkaart> = new EventEmitter<Signaalkaart>();

  onSignaalkaartClick(signaalkaart: Signaalkaart): void {
    this.signaalkaartClicked.emit(signaalkaart);
  }
}
